import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexRowDiv } from "./common.styles";
export const DesignSystemSection = styled.div `
    margin-bottom: 40px;
`;
export const DesignSystemTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    margin-bottom: 10px;
`;
export const DesignSystemDemoViewParent = styled.div `
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black};
    padding: 20px 60px;
`;
export const DesignSystemSubtitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 10px;
`;
export const DesignSystemColorSwatchAndLabel = styled.div `
    font-size: 10px;
    margin: 16px;
`;
export const DesignSystemColors = styled(FlexRowDiv) `
    max-width: 900px;
    flex-wrap: wrap;
`;
export const DesignSystemColorSwatch = styled.div `
    width: 128px;
    height: 128px;
`;
